import type { SerilogCompactFormatLogEvent } from "@octopusdeploy/logging";
import type { Client, RequestContext } from "../client";
export class LogRepository {
    constructor(private readonly client: Client, private readonly requestContext: RequestContext) { }
    ingestLogEvents(logEvents: SerilogCompactFormatLogEvent[]): Promise<void> {
        return this.client.post(this.requestContext, "/ingest", serializeLogEvents(logEvents));
    }
}
function serializeLogEvents(logEvents: SerilogCompactFormatLogEvent[]) {
    // https://github.com/OctopusDeploy/OctopusDeploy/blob/master/docs/OBSERVABILITY/Logging.md#server-log-ingestion-api
    return logEvents.map((l) => JSON.stringify(l)).join("\n");
}
